export const USER_TYPE = {
    INTERNAL: "INTERNAL",
    PARTNER: "PARTNER",
    CUSTOMER: "CUSTOMER"
};

export const PRODUCT_NAME = {
    JIRA: "JIRA",
    CONFLUENCE: "CONFLUENCE"
} as const;
